import React from 'react'
import * as S from '../styles'

export const Checkbox = ({
  name,
  labelTitle,
  checked = false,
  onChange,
  labelStyle,
  labelPosition = 'left',
  ...rest
}) => {
  return (
    <>
      {labelPosition === 'left' &&
      <S.Label htmlFor={name} style={{ ...labelStyle }}>
        {labelTitle}
      </S.Label>
      }
      <S.Checkbox
        name={name}
        id={name}
        checked={checked}
        onChange={onChange}
        {...rest}
      />
       {labelPosition === 'right' &&
      <S.Label htmlFor={name} style={{ ...labelStyle }}>
        {labelTitle}
      </S.Label>
}
    </>
  )
}
